module.exports = __webpack_public_path__ + "static/media/IMG_0551.b6de8a4d.jpg";